import React from 'react';
import { useField } from 'formik';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

interface IProps {
  name: string
  label: string
}

const XSwitchInput = (props: IProps) => {
  const { name, label } = props;
  const [field] = useField({ name });

  return (
    <FormControlLabel
      sx={{
        paddingTop: 1
      }}
      label={label}
      control={(
        <Switch
          checked={Boolean(field.value)}
          value={Boolean(field.value)}
          onChange={field.onChange}
          onBlur={field.onBlur}
          name={name}
          color="primary"
        />
          )}
    />
  );
};
export default XSwitchInput;
